//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockTransAllocations', {
//        templateUrl: 'views/components/views/stockTransAllocations/stockTransAllocations.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stockTransAllocationsService', function ($stateParams, stockTransAllocationsService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
            
//            vm.model = {
//                setting: {},
//                itemsListAllocations: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await stockTransAllocationsService.getSetting({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }
            
//            async function loadAllocations() {
//                return vm.model.itemsListAllocations = await stockTransAllocationsService.listAllocations(vm.model.setting);
//            }

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadAllocations();
//            }
//        }]
//    });
//})();
